import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import HoverableHyperLink from 'components/Core/HyperLink/HoverableHyperLink';

const FooterItems = ({ filteredNavElements, groups }) => {
  const groupCols = groups.slice(0, -1);

  const FooterLink = ({ navItem, customClass }) => (
    <div className={`mega-menu--footer-item ${customClass}`}>
      <div className={`mega-menu--footer-item-content ${customClass}-content`}>
        <HyperLink href={navItem?.url}>{navItem?.label}</HyperLink>
      </div>
    </div>
  );

  return groupCols.map((col, index) => {
    const isFirstItem = index === 0;
    const isThirdItem = index === groupCols.length - 3;
    const isSecondToLastItem = index === groupCols.length - 2;

    if (isFirstItem) {
      return (
        <HoverableHyperLink
          key={index}
          className="mega-menu--footer-item see-all"
          href={filteredNavElements.Footer[0]?.url}
          text={filteredNavElements.Footer[0]?.label}
        />
      );
    } else if (isThirdItem && filteredNavElements.Footer[1]) {
      return (
        <FooterLink key={index} navItem={filteredNavElements.Footer[1]} customClass="comparison" />
      );
    } else if (isSecondToLastItem && filteredNavElements.Footer[2]) {
      return (
        <FooterLink key={index} navItem={filteredNavElements.Footer[2]} customClass="onboarding" />
      );
    }

    return <div key={index} className={`mega-menu--footer-item spacer`} />;
  });
};

export default FooterItems;
